import { useState } from "react";
import { useNavigate, Navigate } from "react-router";
import { Input } from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { Loader } from "../../components/Loader";
import { login } from "../../services";
import { toast } from "react-toastify";
import { getAuthToken, setAuthToken, setAuthUser } from "../../helpers";
import { useUserStore } from "../../zustand/auth";
import { AuthShell } from "../../components/Auth/AuthShell";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { updateToken, updateUserData } = useUserStore();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });

  const handleLogin = async () => {
    setLoading(true);
    try {
      const r = await login(form);
      if (r?.data?.user?.role?.name !== "user") {
        setAuthToken(r.data.token);
        setAuthUser(r.data.user);
        updateToken(r.data.token);
        updateUserData(r.data.user);
        toast("Welcome to BudgIT Admin", { type: "success" });
        navigate("/");
      } else {
        toast("Unauthorized access", { position: "bottom-right", type: "error" });
      }
    } catch (err: any) {
      // 1. Try to get detailed error from nested structure: { error: { message: "..." } }
      // 2. Try to get direct message: { message: "..." }
      // 3. Fallback to a string error or a generic message
      const errorMsg = err?.error?.message || err?.message || (typeof err === 'string' ? err : "An unexpected authentication error occurred");
      toast("Error: " + errorMsg, { position: "bottom-right", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  if (getAuthToken()) return <Navigate to="/" />;

  return (
    <AuthShell heading="Sign in" subheading="Enter your credentials to continue">
      <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }} className="flex flex-col gap-5">
        <Input
          type="email"
          label="Admin Email"
          placeholder="e.g. admin@budgit.org"
          value={form.email}
          action={(e) => setForm({ ...form, email: e.target.value })}
          autoCapitalize="none"
          autoComplete="email"
          autoCorrect="off"
        />

        <div className="relative">
          <Input
            type="password"
            label="Security Password"
            placeholder="••••••••••••"
            value={form.password}
            action={(e) => setForm({ ...form, password: e.target.value })}
            mb={false}
          />
          <div className="flex justify-end mt-2">
            <button
              type="button"
              onClick={() => navigate("/forgot-password")}
              className="text-xs font-semibold text-primary-700 hover:text-primary-900 underline underline-offset-2 transition-colors focus:outline-none"
            >
              Forgot password?
            </button>
          </div>
        </div>

        <Button
          title={loading ? "Authenticating..." : "Secure Sign In"}
          className="mt-4 w-full !py-3.5 shadow-md shadow-primary-900/20 hover:shadow-lg hover:shadow-primary-900/30 transition-shadow"
          size="lg"
          disabled={!form.email || !form.password || loading}
          icon={loading ? <Loader /> : undefined}
          type="submit"
          action={() => { }}
        />
      </form>
    </AuthShell>
  );
};

export default AdminLogin;
